
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { useContext, useState } from 'react';
import DialogGenSecretKey from './dialogGenKey';
import { EXPORT_DATA_API_URL } from '../../constants/api_url'
import { AppContext } from '../../contexts/AppContext';
import { ROLES } from '../../constants/enums';

const jsExmaple1 = `const myHeaders = new Headers();
myHeaders.append("x-api-key", "your secret key");

const requestOptions = {
  method: "GET",
  headers: myHeaders,
  redirect: "follow"
};

fetch("${EXPORT_DATA_API_URL}/plot", requestOptions)
  .then((response) => response.text())
  .then((result) => console.log(result))
  .catch((error) => console.error(error));`

const jsExmaple2 = `const myHeaders = new Headers();
myHeaders.append("x-api-key", "your secret key");

const requestOptions = {
  method: "GET",
  headers: myHeaders,
  redirect: "follow"
};

fetch("${EXPORT_DATA_API_URL}/export-data/Plot/search-plot?uid=1&plotId=1&ContractId=1&CreateDateStart=2024-09-30T07:26:22.9454000Z&CreateDateEnd=2024-09-30T07:26:22.9454000Z", requestOptions)
  .then((response) => response.text())
  .then((result) => console.log(result))
  .catch((error) => console.error(error));`

const mockDataResponse1 = {
    "status": "success",
    "data": [
        {
            "uid": "696465fa-eabb-4f6b-a40f-01a01d2244bc",
            "fullName": "name surname",
            "deedNo": "1",
            "cardId": "1100000000000",
            "size": 74.02,
            "address": "address",
            "detail": "detail",
            "farms": [],
            "areaName": "Area 1",
            "teamName": "team 1",
            "employeeFullName": "name surname",
            "enterpriseName": "CompanyA",
            "createdDate": "2024-09-04T05:18:50.2497",
            "updatedDate": "2024-09-04T05:18:50.2497"
        }
    ]
}

const mockDataResponse2 = {
    "status": "success",
    "data": [
        {
            "uid": "111",
            "fullName": "text",
            "deedNo": "1",
            "cardId": "xxxxxxxxxxxxx",
            "sizeRai": 0,
            "sizeNgan": 0,
            "sizeWah": 18,
            "sizeRaiNganWah": "0 ไร่ 0 งาน 18 วา",
            "size": 74.02,
            "address": "text",
            "detail": "text",
            "polygon": [
                {
                    "latitude": 0,
                    "longitude": 0
                },
                {
                    "latitude": 0,
                    "longitude": 0
                },
                {
                    "latitude": 0,
                    "longitude": 0
                },
                {
                    "latitude": 0,
                    "longitude": 0
                }
            ],
            "farms": [],
            "areaName": "text",
            "teamName": "text",
            "employeeFullName": "text",
            "enterpriseName": "text",
            "plotId": "",
            "contractId": "",
            "phoneNo": "xxxxxxxxxx",
            "midPoint": {
                "latitude": 0,
                "longitude": 0
            },
            "createdDate": "2024-09-04T05:18:50.2497",
            "updatedDate": "2024-09-04T05:18:50.2497",
            "currentLatitude": 0,
            "currentLongitude": 0,
            "currentAddress": "text",
            "midPointLatitude": 0,
            "midPointLongitude": 0,
            "DistanceBetweenCurrentWithMidpoint": 0
        },
    ]
}
const mockData401Response = {
    "type": "https://tools.ietf.org/html/rfc7235#section-3.1",
    "title": "Unauthorized",
    "status": 401,
    "traceId": "00-3b710fc95634e4dcb7ab48a0fecd38ec-b16adc1fb92ea286-00"
}

export default function ApiSettingsPage() {
    const { employee = {} } = useContext(AppContext)
    const isAdminLing = ROLES.AdminLing === employee.role


    function createData(
        name,
        description,
        type
    ) {
        return { name, description, type };
    }
    // คำอธิบายอ้างอิงจาก summary ใน class model หลังบ้าน 
    const rowApiGetAll = [
        createData('status', 'สถานะการตอบกลับ success | error | 401', 'string | number'),
        createData('message', 'ข้อความกรณีเกิดข้อผิดพลาด', 'string'),
        createData('data', 'ข้อมูลตอบกลับ', 'object'),
        createData('data.plots', 'ข้อมูลแปลงทั้งหมด', 'array object'),
        createData('data.plots[].uid', 'หมายเลขประจำตัวเกษตรกร', 'string'),
        createData('data.plots[].fullName', 'ชื่อ-นามสกุลเกษตรกร', 'string'),
        createData('data.plots[].deedNo', 'หมายเลขโฉนด', 'string'),
        createData('data.plots[].cardId', 'หมายเลขบัตรประชาชน', 'string'),
        createData('data.plots[].sizeRai', 'ขนาดแปลงหน่วย (ไร่)', 'float'),
        createData('data.plots[].sizeNgan', 'ขนาดแปลงหน่วย (งาน) ', 'float'),
        createData('data.plots[].sizeWah', 'ขนาดแปลงหน่วย (วา)', 'float'),
        createData('data.plots[].sizeRaiNganWah', 'ขนาดแปลง ไร่ งาน วา', 'string'),
        createData('data.plots[].address', 'ที่อยู่แปลง', 'string'),
        createData('data.plots[].detail', 'รายละเอียดแปลง หรือจุดสังเกต', 'string'),
        createData('data.plot[].polygon', 'พิกัด polygon ของแปลง', 'string'),
        createData('data.plots[].farms', 'ข้อมูลฟาร์มในแปลง', 'array object'),
        createData('data.plots[].farms[].plantTypeName', 'ชนิดพืช', 'string'),
        createData('data.plots[].farms[].plantName', 'พันธุ์พืช', 'string'),
        createData('data.plots[].farms[].startDate', 'วันที่ปลูก', 'string'),
        createData('data.plots[].farms[].completedDate', 'วันที่เก็บเกี่ยว', 'string'),
        createData('data.plots[].areaName', 'พื้นที่รับผิดชอบ', 'string'),
        createData('data.plots[].teamName', 'ทีมที่รับผิดชอบ', 'string'),
        createData('data.plots[].employeeFullName', 'ผู้รับผิดชอบ', 'string'),
        createData('data.plots[].enterpriseName', 'ชื่อบริษัท', 'string'),
        createData('data.plots[].createdDate', 'วันที่สร้างแปลง', 'string'),
        createData('data.plots[].updatedDate', 'วันที่ อัพเดทแปลงล่าสุด', 'string')
    ];

    const rowApiSearchAll = [
        createData('status', 'สถานะการตอบกลับ success | error | 401', 'string | number'),
        createData('message', 'ข้อความกรณีเกิดข้อผิดพลาด', 'string'),
        createData('data', 'ข้อมูลตอบกลับ', 'object'),
        createData('data.plots', 'ข้อมูลแปลงทั้งหมด', 'array object'),
        createData('data.plots[].uid', 'หมายเลขประจำตัวเกษตรกร', 'string'),
        createData('data.plots[].fullName', 'ชื่อ-นามสกุลเกษตรกร', 'string'),
        createData('data.plots[].deedNo', 'หมายเลขโฉนด', 'string'),
        createData('data.plots[].cardId', 'หมายเลขบัตรประชาชน', 'string'),
        createData('data.plots[].sizeRai', 'ขนาดแปลงหน่วย (ไร่)', 'float'),
        createData('data.plots[].sizeNgan', 'ขนาดแปลงหน่วย (งาน) ', 'float'),
        createData('data.plots[].sizeWah', 'ขนาดแปลงหน่วย (วา)', 'float'),
        createData('data.plots[].sizeRaiNganWah', 'ขนาดแปลง ไร่ งาน วา', 'string'),
        createData('data.plots[].address', 'ที่อยู่แปลง', 'string'),
        createData('data.plots[].detail', 'รายละเอียดแปลง หรือจุดสังเกต', 'string'),
        createData('data.plot[].polygon', 'พิกัด polygon ของแปลง', 'string'),
        createData('data.plots[].farms', 'ข้อมูลฟาร์มในแปลง', 'array object'),
        createData('data.plots[].farms[].plantTypeName', 'ชนิดพืช', 'string'),
        createData('data.plots[].farms[].plantName', 'พันธุ์พืช', 'string'),
        createData('data.plots[].farms[].startDate', 'วันที่ปลูก', 'string'),
        createData('data.plots[].farms[].completedDate', 'วันที่เก็บเกี่ยว', 'string'),
        createData('data.plots[].areaName', 'พื้นที่รับผิดชอบ', 'string'),
        createData('data.plots[].teamName', 'ทีมที่รับผิดชอบ', 'string'),
        createData('data.plots[].employeeFullName', 'ผู้รับผิดชอบ', 'string'),
        createData('data.plots[].enterpriseName', 'ชื่อบริษัท', 'string'),
        createData('data.plots[].createdDate', 'วันที่สร้างแปลง', 'string'),
        createData('data.plots[].updatedDate', 'วันที่ อัพเดทแปลงล่าสุด', 'string'),
        createData('data.plots[].plotId', 'หมายเลขแปลง(ID)', 'string'),
        createData('data.plots[].contractId', 'เลขที่สัญญา', 'string'),
        createData('data.plots[].phone', 'เบอร์โทร', 'string'),
        createData('data.plots[].midPoint', 'ค่าพิกัดกลางแปลง', 'object'),
        createData('data.plots[].currentLatitude', 'ละติจูดปัจจุบัน', 'number'),
        createData('data.plots[].currentLongitude', 'ลองจิจูดปัจจุบัน', 'number'),
        createData('data.plots[].currentAddress', 'ที่อยู่ปัจจุบัน', 'string'),
        createData('data.plots[].midPointLatitude', 'ละติจูดกลางแปลง', 'number'),
        createData('data.plots[].midPointLongitude', 'ลองจิจูดกลางแปลง', 'number'),
        createData('data.plots[].DistanceBetweenCurrentWithMidpoint', 'ระยะห่างจุดวาดกับพิกัดกลางแปลง/เมตร', 'number'),
    ];

    const rowApiSearchAllQuery = [
        createData('uid', 'ค้นหาจากหมายเลขประจำตัวเกษตรกร', 'string'),
        createData('plotId', 'ค้นหาจากหมายเลขแปลง(ID)', 'string'),
        createData('contractId', 'ค้นหาจากเลขที่สัญญา', 'string'),
        createData('createDateStart', 'วันที่สร้างแปลงตั้งแต่', 'string datetime iso 8601'),
        createData('createDateEnd', 'วันที่สร้างแปลงจนถึง', 'string datetime iso 8601'),
    ]


    return <div style={{ margin: 40 }}>
        <Grid container spacing={3}>
            <Grid container item direction="row" justifyContent="space-between">
                <Grid item xs={12} md={6}><h3>รายการ API</h3></Grid>
                <Grid item xs={12} md={3}>
                    <DialogGenSecretKey />
                </Grid>
            </Grid>

            <Grid item xs={12}>
                {isAdminLing && <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <b>ข้อมูลพื้นที่แปลงของทุกบริษัท</b>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}><b>Base URL </b></Grid>
                            <Grid item xs={12} md={8} style={{ wordBreak: 'break-word' }}>{`${EXPORT_DATA_API_URL}/plot`}</Grid>
                            <Grid item xs={12} md={4}><b>คำอธิบายข้อมูล</b></Grid>
                            <Grid item xs={12} md={8} style={{ wordBreak: 'break-word' }}>ข้อมูลพื้นที่แปลงของทุกบริษัท</Grid>
                            <Grid item xs={12} md={4}><b>HTTP Request Method</b></Grid>
                            <Grid item xs={12} md={8} style={{ wordBreak: 'break-word' }}>GET</Grid>
                            <Grid item xs={12} md={4}><b>Query String</b></Grid>
                            <Grid item xs={12} md={8} style={{ wordBreak: 'break-word' }}>ไม่มี</Grid>
                            <Grid item xs={12} md={4}><b>Authentication</b></Grid>
                            <Grid item xs={12} md={8} style={{ wordBreak: 'break-word' }}>แนบ Secret Key มาใน Header x-api-key</Grid>

                            <Grid item xs={12}><b>รายละเอียดข้อมูลตอบกลับ</b></Grid>
                            <Grid item xs={12}>
                                <TableContainer>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>ชื่อฟิลด์</TableCell>
                                                <TableCell >คำอธิบาย</TableCell>
                                                <TableCell >ประเภทตัวแปร</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rowApiGetAll.map((row) => (
                                                <TableRow
                                                    key={row.name}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {row.name}
                                                    </TableCell>
                                                    <TableCell >{row.description}</TableCell>
                                                    <TableCell >{row.type}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Grid item xs={12}><b>ตัวอย่างข้อมูลเมื่อเรียกใช้งานสำเร็จ</b></Grid>
                            <Grid item xs={12}>
                                <div><b>HTTP Request Status 200 Ok</b></div>
                                <div style={{ overflowX: 'scroll' }}><pre>{JSON.stringify(mockDataResponse1, null, 2)}</pre></div>
                            </Grid>
                            <Grid item xs={12}><b>ตัวอย่างข้อมูลเมื่อ Secret Key ไม่ถูกต้อง</b></Grid>
                            <Grid item xs={12}>
                                <div><b>HTTP Request Status 401</b></div>
                                <div style={{ overflowX: 'scroll' }}><pre>{JSON.stringify(mockData401Response, null, 2)}</pre></div>
                            </Grid>
                            <Grid item xs={12}><b>ตัวอย่างการใช้งานใน ภาษา Javascript</b></Grid>
                            <Grid item xs={12}>
                                <div style={{ overflowX: 'scroll' }}>
                                    <pre>
                                        {jsExmaple1}
                                    </pre>
                                </div>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>}
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        <b>ค้นหาข้อมูลพื้นที่แปลง</b>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}><b>Base URL </b></Grid>
                            <Grid item xs={12} md={8} style={{ wordBreak: 'break-word' }}>{`${EXPORT_DATA_API_URL}/plot/search-plot`}</Grid>
                            <Grid item xs={12} md={4}><b>คำอธิบายข้อมูล</b></Grid>
                            <Grid item xs={12} md={8} style={{ wordBreak: 'break-word' }}>ค้นหาข้อมูลพื้นที่แปลง</Grid>
                            <Grid item xs={12} md={4}><b>HTTP Request Method</b></Grid>
                            <Grid item xs={12} md={8} style={{ wordBreak: 'break-word' }}>GET</Grid>
                            <Grid item xs={12} md={4}><b>Query String</b></Grid>
                            <Grid item xs={12}>
                                <TableContainer>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>ชื่อฟิลด์</TableCell>
                                                <TableCell >คำอธิบาย</TableCell>
                                                <TableCell >ประเภทตัวแปร</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rowApiSearchAllQuery.map((row) => (
                                                <TableRow
                                                    key={row.name}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {row.name}
                                                    </TableCell>
                                                    <TableCell >{row.description}</TableCell>
                                                    <TableCell >{row.type}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Grid item xs={12} md={4}><b>Authentication</b></Grid>
                            <Grid item xs={12} md={8} style={{ wordBreak: 'break-word' }}>แนบ Secret Key มาใน Header x-api-key</Grid>

                            <Grid item xs={12}><b>รายละเอียดข้อมูลตอบกลับ</b></Grid>
                            <Grid item xs={12}>
                                <TableContainer>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>ชื่อฟิลด์</TableCell>
                                                <TableCell >คำอธิบาย</TableCell>
                                                <TableCell >ประเภทตัวแปร</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rowApiSearchAll.map((row) => (
                                                <TableRow
                                                    key={row.name}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {row.name}
                                                    </TableCell>
                                                    <TableCell >{row.description}</TableCell>
                                                    <TableCell >{row.type}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Grid item xs={12}><b>ตัวอย่างข้อมูลเมื่อเรียกใช้งานสำเร็จ</b></Grid>
                            <Grid item xs={12}>
                                <div><b>HTTP Request Status 200 Ok</b></div>
                                <div style={{ overflowX: 'scroll' }}><pre>{JSON.stringify(mockDataResponse2, null, 2)}</pre></div>
                            </Grid>
                            <Grid item xs={12}><b>ตัวอย่างข้อมูลเมื่อ Secret Key ไม่ถูกต้อง</b></Grid>
                            <Grid item xs={12}>
                                <div><b>HTTP Request Status 401</b></div>
                                <div style={{ overflowX: 'scroll' }}><pre>{JSON.stringify(mockData401Response, null, 2)}</pre></div>
                            </Grid>
                            <Grid item xs={12}><b>ตัวอย่างการใช้งานใน ภาษา Javascript</b></Grid>
                            <Grid item xs={12}>
                                <div style={{ overflowX: 'scroll' }}>
                                    <pre>
                                        {jsExmaple2}
                                    </pre>
                                </div>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>
        </Grid>
    </div>
}